import React, { useCallback, useEffect, useState } from 'react'
import { Redirect, Route } from 'react-router-dom'
import { get, set } from 'local-storage'
import { useGlobalState, useUserDispatcher } from '@hooks'
import { useAxios } from '../hooks/useAxios'

const AuthRoute: React.FC = (props) => {
  const axios = useAxios()
  const globalState = useGlobalState()
  const { setTokenAuthData } = useUserDispatcher()
  const [isReady, setIsReady] = useState(false)

  const fetchTokenAsync = useCallback(async (refreshToken: string) => {
    await axios.get(`auth/refreshToken`, {
      params: {
        refreshToken
      }
    })
      .then(response => {
        set<string>(`token`, response.data.token)
        set<string>(`refreshToken`, response.data.refreshToken)
        setTokenAuthData(response.data.token)
      })
  }, [globalState])

  useEffect(() => {
    const refreshToken = get<string>('refreshToken')

    if (refreshToken) {
      fetchTokenAsync(refreshToken)
        .finally(() => {
          setIsReady(true)
        })
    } else {
      setIsReady(true)
    }
  }, [])

  if (isReady) {
    if (!globalState.user.isAuthenticated) return <Redirect to="/signin" />

    return <Route {...props} />
  }

  return null
}


export default AuthRoute